import { Component, ComponentChild, h } from 'preact'
import Icon from '../assets'
import CSSTransitionGroup from 'preact-css-transition-group'

interface Props {
  title: string,
  trigger: ComponentChild,
  onCallback?: (isOpen: boolean) => void
}

interface State {
  isOpen: boolean
}

class Slider extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.state = {
      isOpen: false
    }

    this.toggleComponent = this.toggleComponent.bind(this)
  }

  toggleComponent (newValue: boolean) {
    this.setState({ isOpen: newValue })
    this.props?.onCallback?.(newValue)
  }

  render ({ trigger, title }: Props, { isOpen }: State) {
    return (
      <div className='slider-menu'>
        <span className='slider-trigger' onClick={() => this.toggleComponent(true)}>
          {trigger}
        </span>
        <CSSTransitionGroup transitionName='slide-right' transitionEnterTimeout={150} transitionLeaveTimeout={150}>
          {
            isOpen ? (
              <div className='slider-content'>
                <div className='slider-header'>
                  <Icon width={21} height={21} icon='close' onClick={() => this.toggleComponent(false)} />
                  <div className='slider-title text-center'>
                    {title}
                  </div>
                </div>
                {
                  this.props.children
                }
              </div>
            ) : null
          }
        </CSSTransitionGroup>
      </div>
    )
  }
}

export default Slider
